import { createFileRoute } from '@tanstack/react-router'
import { RealEstateMapTab } from '~/components/routes/development/real-estate/map/real-estate-map-tab'
import { MAP_READ, realEstateTabGuard } from '~/components/routes/development/real-estate/tabs'

export const Route = createFileRoute('/_authenticated/development/real-estate/map')({
  staticData: { permission: MAP_READ },
  beforeLoad: realEstateTabGuard('map'),
  component: RealEstateMapTab,
})
